import { useCallback, useState } from "react";
import { toast } from "sonner";
import axios from "./axios";

export const useAchievements = () => {
  const [loadingAcheivements, setLoadingAcheivements] = useState(false);
  const [loadingBoard, setLoadingBoard] = useState(false);
  const [loadingId, setLoadingId] = useState(null);
  const [loadingHistory, setLoadingHistory] = useState(false);
  const [leaderboardData, setLeadboardData] = useState([]);
  const [redeemdData, setRedeemData] = useState([]);
  const [historyData, setHistoryData] = useState([]);
  const [achievements, setAchievements] = useState([]);
  const [campaignLeaderboard, setCampaignLeaderboard] = useState([]);

  // const getLeadboard = async (filter) => {
  //   setLoadingAcheivements(true);
  //   try {
  //     const res = await axios.get(
  //       `/audiences/general/overall-leaderboard/${filter}`
  //     );
  //     if (res.status === 200) {
  //       setLoadingAcheivements(false);
  //       setLeadboardData(res?.data?.data);
  //     }
  //   } catch (err) {
  //     setLoadingAcheivements(false);
  //     toast.error(err?.response?.data?.message);
  //   }
  // };
  const getLeadboard = useCallback(async (filter, campaign_id) => {
    setLoadingBoard(true);

    try {
      const res = await axios.get(
        `/audiences/arena-leaderboard?filter=${filter}${campaign_id ? `&campaign_id=${campaign_id}` : ""}`,
      );

      setLoadingBoard(false);
      if (res.status === 200) {
        setLoadingBoard(false);

        if (campaign_id) {
          setCampaignLeaderboard(res.data);
        } else {
          setLeadboardData(res?.data);
        }
      }
    } catch (err) {
      setLoadingBoard(false);
      toast.error(err?.response?.data?.message);
    }
  }, []);

  const getArenaAcheivements = async () => {
    setLoadingAcheivements(true);
    try {
      const res = await axios.get(`/audiences/arena/achievements`);
      if (res.status === 200) {
        setLoadingAcheivements(false);
        setAchievements(res?.data);
      }
    } catch (err) {
      setLoadingAcheivements(false);
      toast.error(err?.response?.data?.message);
    }
  };

  const handleRedeemPrize = async (redeemId) => {
    try {
      setLoadingId(redeemId);
      const res = await axios.put(`/audiences/brand-reward/${redeemId}`);
      if (res.status === 200) {
        setLoadingId(null);
        setRedeemData(res?.data?.data);
        return true;
      }
      return false;
    } catch (err) {
      setLoadingId(null);
      toast.error(err?.response?.data?.message);
      return false;
    }
  };

  const getRedeemHistory = async (brandId, type) => {
    try {
      setLoadingHistory(true);
      const res = await axios.get(
        `/audiences/redeem-history/brand/${brandId}?filter=${type}`,
      );
      if (res.status === 200) {
        setLoadingHistory(false);
        setHistoryData(res?.data?.data);
      }
    } catch (err) {
      setLoadingHistory(false);
      toast.error(err?.response?.data?.message);
    }
  };

  return {
    getLeadboard,
    loadingAcheivements,
    leaderboardData,
    handleRedeemPrize,
    redeemdData,
    loadingId,
    loadingHistory,
    historyData,
    getRedeemHistory,
    loadingBoard,
    campaignLeaderboard,
    getArenaAcheivements,
    achievements,
  };
};
